import React from "react";

import LoginV2 from "../components/loginV2";

export default function SignIn() {
  return <LoginV2 />;
}
